<div class="flex-row start-center gap-24">
  @for (tab of tabs(); track tab.value) {
    <button
      type="button"
      class="view-button"
      [class.active]="activeTab() === tab.value"
      (click)="selectTab(tab.value)"
    >
      <div [ngClass]="{ 'svg-fill-primary': activeTab() === tab.value }">
        <span [class]="tab.iconName"></span>
      </div>
      <span>{{ tab.labelKey | translate }}</span>
      <div class="count">{{ tab.count() }}</div>
    </button>
  }
</div>
